// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-group {
  margin-bottom: 0;
}

label {
  font-size: 1.25rem;
  margin-bottom: 0;
}

i {
  color: #000;
}

.col-md-6 {
  border: 1px solid #979797;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./libs/msslib/src/lib/components/formly/wrappers/table-row/table-row-wrapper.component.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;AADF;;AAIA;EACE,kBAAA;EACA,gBAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,yBAAA;EACA,mBAAA;EACA,sBAAA;AADF","sourcesContent":["@use 'mssvariables' as *;\n\n.form-group {\n  margin-bottom: 0;\n}\n\nlabel {\n  font-size: 1.25rem;\n  margin-bottom: 0;\n}\n\ni {\n  color: theme-color('dark');\n}\n\n.col-md-6 {\n  border: 1px solid theme-color('medium-grey');\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
